import React from 'react'

import { Flex, HStack, Icon, QuickTip, Text, VStack } from 'govwell-ui'

type Props = {
  percentAfterHours: number
  afterHoursQuestions: number
  compact?: boolean
  tooltip?: string
}

const AfterHoursCard = ({ percentAfterHours, afterHoursQuestions, compact, tooltip }: Props) => {
  return (
    <HStack
      gap={4}
      align="center"
      className="h-full w-full rounded-lg border border-solid border-gray-200 bg-gradient-to-r from-indigo-50 to-cyan-50 p-5"
    >
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-indigo-100">
        <Icon icon="FaMoon" className="text-lg text-indigo-600" />
      </div>
      <Flex direction="row" gap={6} align="center" className="flex-1">
        <VStack gap={0}>
          <HStack gap={1} align="center">
            <Text.BodySmall className="text-gray-500 uppercase">After-Hours Usage</Text.BodySmall>
            {tooltip && compact && <QuickTip content={tooltip} />}
          </HStack>
          <Text.BodyLarge className="font-bold text-indigo-600">
            {percentAfterHours}%
          </Text.BodyLarge>
        </VStack>
        {!compact && (
          <>
            <div className="h-10 w-px bg-gray-300" />
            <VStack gap={0}>
              <Text className="text-[9px] text-gray-400 uppercase">Questions Outside 9–5 M-F</Text>
              <Text.H2 className="font-bold text-indigo-600">{afterHoursQuestions}</Text.H2>
            </VStack>
          </>
        )}
      </Flex>
    </HStack>
  )
}

export default React.memo(AfterHoursCard)
